import React, { useEffect, useState } from "react";
import { useAllCoderAttributes } from "./hooks/use-all-coder-attributes";
import { useAllCoderGroups } from "./hooks/use-all-coder-groups";
import { useReferences } from "components/attributes/references/hooks/useReferences";
import Accordion from "components/accordion";
import DualCodingAttributeTable from "components/attributes/dual-coding-attribute-table";
import Loader from "components/loader/loader";

const CodingQAIndex = ({
    codingWipKey,
    showReferences,
    showValidation,
    onHideControls,
    taskKey,
    hasRedo,
    setHasRedo,
    isReadOnlyAdd,
    isReadOnlyEdit,
    isReadOnlyDelete,
    isRefreshing,
    setRefresh,
    isBrandVerified,
}) => {
    const { data: codingRoles, isSuccess, refetch: refetchCoderRoles } = useAllCoderAttributes(codingWipKey);
    const { references, selectReferences, selectStyles } = useReferences();
    const {
        data: codingGroups,
        isSuccess: groupsFetched,
        isLoading: groupsLoading,
        refetch: refetchCoderGroups,
    } = useAllCoderGroups(codingWipKey, taskKey, codingRoles, [...references.activeProductKeys], isSuccess, isBrandVerified);

    const [roles, setRoles] = useState([]);

    useEffect(() => {
        if (isSuccess && codingRoles) {
            setRoles(Object.keys(codingRoles));
            setHasRedo(codingRoles.hasRedo);
        }
    }, [isSuccess, codingRoles]);

    const accordionGroup = roles
        .filter((r) => r !== "hasRedo" && r !== "subTaskKeys")
        .map((label, index) => {
            return (
                codingGroups && (
                    <div
                        key={index}
                        label={`${label} Attributes`}
                        style={{ marginBottom: "24px" }}
                    >
                        <DualCodingAttributeTable
                            showReferences={showReferences}
                            showValidation={showValidation}
                            onHideControls={onHideControls}
                            isQa={true}
                            taskType={"codingqa.standard"}
                            roleLabels={codingRoles[label]}
                            group={codingGroups[label]}
                            groupsFetched={groupsFetched}
                            isGroupsLoading={groupsLoading}
                            refetchCoderRoles={refetchCoderRoles}
                            refetchCoderGroups={refetchCoderGroups}
                            hasRedo={hasRedo}
                            setHasRedo={setHasRedo}
                            isReadOnlyAdd={isReadOnlyAdd}
                            isReadOnlyEdit={isReadOnlyEdit}
                            isReadOnlyDelete={isReadOnlyDelete}
                            isRefreshing={isRefreshing}
                            setRefresh={setRefresh}
                            coderTypeLabel={label}
                            isBrandVerified={isBrandVerified}
                        />
                    </div>
                )
            );
        });

    if (!groupsFetched || !isSuccess) {
        return (
            <div className="txt-center">
                <Loader natural={true} />
            </div>
        );
    }

    return (
        <div className="attribute-content">
            {selectReferences}
            <Accordion
                style={selectStyles}
                className="accordion-attributes"
                openAll
            >
                {accordionGroup}
            </Accordion>
        </div>
    );
};

export default CodingQAIndex;
